import React from 'react'
import "./Footer.css"

const Footer = () => {
  return (
    <div className='footer'>
     <div className='section'>
     <div className='one'>
<div>
<img src='/assets/31b6c826-c6d1-4d4d-a674-b25c52bbdacb 1.png'/>

  </div>
       </div>
      <div className='two'>
        <h1>معلومات عن العياده</h1>
        <p>
        أول عيادة متخصصة في علاج تاخر الحمل والإنجاب بإستخدام كافة اساليب الأخصاب المساعد و إستخدامأحدث الأساليب العلمية والعلاجية للوصول لإعلي نسبة فـــ مصر   
        </p>
      </div>
      <div className='three'>
        <h1>معلومات التواصل</h1>
        <p>
          <span>           <img src="/assets/OIP__74_-removebg-preview 5@2x.svg" alt="Additional logo" style={{ height: "27.85px", width: "27.81px",  }} />
          <span>01149533395</span>

          </span>

        </p>
        <p>

          <span>          <img src="/assets/OIP__74_-removebg-preview 5@2x.svg" alt="Additional logo" style={{ height: "27.85px", width: "27.81px",  }} />
          <span>01007772199</span>

          </span>

        </p>
        <p>
          <span>         
             <a
      href="https://www.instagram.com/dr.mostafa.el.khosht?igsh=MWp6YnJhZmh1aGZkcw=="
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none", color: "inherit" ,display:"inline-block" }} // Optional styling
    >
      <img
        src="/assets/1-19361_watercolor-instagram-icon-png-instagram-logo-white-on 1@2x.svg"
        alt="Instagram Logo"
        style={{display:"inline-block", height: "28px", width: "28px", verticalAlign: "middle" }}
      />
    </a>
          <span>dr.mostafa.el.khosht</span>

          </span>

        </p>
        <p>
          <span>           
          <a
      href="https://www.facebook.com/share/1EtzuzayQY/?mibextid=qi2Omg"
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none", color: "inherit" ,display:"inline-block" }} // Optional styling
    >
      <img
        src="/assets/facebook-logo-white-11549845815wclpvkfdsb-removebg-preview 1.svg"
        alt="Facebook Logo"
        style={{ height: "28px", width: "28px", verticalAlign: "middle" }}
      />
   
    </a>
          <span>الحقن المجهري مع دكتور مصطفي الخشت</span>

          </span>

        </p>
      </div>
      <div className='four'>

      <img src="/assets/Dr.Mostafa Logo 2.png" alt="Dr. Mostafa Logo" />
      </div>

     </div>
     <div className="footer-copyright">
  <p>© 2024 عيادة الدكتور مصطفى الخشت. جميع الحقوق محفوظة.</p>
</div>

    </div>
  )
}

export default Footer